// extracted by mini-css-extract-plugin
export default {"card-link":"CkGry","link":"PKZYY"};